var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('base-header',{staticClass:"pb-6 pb-8 pt-5 pt-md-7 bg-gradient"},[_c('h1',[_vm._v("Получение")])]),_c('b-container',{staticClass:"mt--7",attrs:{"fluid":""}},[_c('b-row',[_c('b-col',[_c('div',{staticClass:"content_block"},[_c('BaseTable',{attrs:{"type":_vm.type}}),(_vm.loading)?_c('div',[_vm._v("loading...")]):_vm._e()],1)])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }